import { BoardEntryEdit } from '@/models/settouMessageBoard';

// 「内容」「連絡事項」に保存できるトークン数（装飾の HTML タグを含む文字数）の上限。DB の列長と同じ値にする
export const CONTENT_REPLY_MAX_TOKEN_COUNT = 5000;
export const editingBoardEntryDefault: BoardEntryEdit = {
  id: 0,
  dispNo: null,
  timestamp: '',
  date: null,
  time: null,
  companyName: null,
  han: null,
  isReportedToHonsha: false,
  content: null,
  reply: null,
  saveFiles: [],
  removeFileIds: [],
  isBulkDistribute: false,
  isPinned: false,
};
